import React from "react";
import { Box, Typography, Grid, Link } from "@mui/material";
import { Phone, Mail, LocationOn, WhatsApp } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#212121",
        color: "#FFC107",
        py: 5,
        px: { xs: 2, sm: 3, md: 10 },
      }}
    >
      <Grid container spacing={4}>
        {/* Columna de Teléfonos */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ mb: 2, color: "#FFC107" }}>
            Teléfonos
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <WhatsApp sx={{ mr: 1 }} />
            <Typography variant="body2">+57 324 497 0734</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Phone sx={{ mr: 1 }} />
            <Typography variant="body2">
              +57 310 684 0864 (Emergencias)
            </Typography>
          </Box>
        </Grid>

        {/* Columna de Información (Correo y Ubicación) */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" sx={{ mb: 2, color: "#FFC107" }}>
            Información
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Mail sx={{ mr: 1 }} />
            <Typography variant="body2">
              <Link
                href="mailto:Gerencia@omcingenieria.com"
                sx={{ color: "#FFC107", textDecoration: "none" }}
              >
                Gerencia@omcingenieria.com
              </Link>
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LocationOn sx={{ mr: 1 }} />
            <Typography variant="body2">Carrera 75 #32-55 int 201</Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Copyright */}
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography variant="body2">
          &copy; {new Date().getFullYear()} Ascensores. Todos los derechos
          reservados.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
